import * as React from 'react';
import { isPastDate } from 'owa-observable-datetime';
import { observer } from 'mobx-react';
import { OwaDate } from 'owa-datetime';

const styles = require('./ColumnPastDayHighlightBehavior.scss');

/* tslint:disable:use-mobx-react-lite-with-hooks
 * Using mobx-react-lite with functional components breaks the Calendar "behavior" architecture.
 * WI:47082 tracks refactoring this architecture.
 */
export default observer(function ColumnPastDayHighlightBehavior({ date }: { date: OwaDate }) {
    return isPastDate(date) ? <div className={styles.pastHighlight} /> : null;
});
